<template>
    <div class=" request">
        <div class="row justify-content-center">
            <div class="col-md-12 px-0 mx-0">

                <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>


                <div style="min-height: unset; padding-bottom: 52px; padding-top: 8rem;" class="header-show-image header-request-show-image-parallax">
                    <div style="max-width: 1200px; width: 100%" class="header-request-title-block align-items-center d-flex mx-auto flex-column">
                        <h1 class="text-start text-md-center mb-5 col-md-9">


                            {{ lang === 'ar-sa' ? `طلب تصميم نموذج ثلاثي الأبعاد`
                            :
                            'Request a 3D Model Design'
                            }}


                        </h1>
                        <p style="max-width: 900px" class="text-start text-md-center">
                             {{ lang === 'ar-sa' ? 'عندك فكرة رهيبة لتصميم 3D؟ لكن ما عندك خبرة او تحتاج مساعدة في التصميم؟ خبرائنا يساعدوك في تصميم نموذجك وطباعته من الصفر. راح يتم تصميم فكرتك وبتكون جاهزة خلال 10 أيام، والمنتج النهائي عندك خلال 15 يوم بالكثير، والنتائج تستحق الانتظار. كل اللي عليك هو أنك تتواصل معنا.'
                                :
                                'Have a brilliant idea for a 3D-printed masterpiece but lack the technical skills to create a 3D model? We are here to bring your imagination to life! Creating sketches takes up to 10 days, and with 3D printing, up to 15 days. Don’t let the lack of sketches hold you back – contact us today and turn your ideas into reality!'
                            }}
                        </p>

                        <div class="d-flex mx-md-auto btn__block btn__block_request">
                            <a href="#form-request__design-block"
                                class="btn text-decoration-none btn-light-purple btn__block__btn me-md-3">
                                {{ lang === 'ar-sa' ? 'تقديم طلب التصميم' : 'Make Design Request'}}
                            </a>
                            <a href="/contact-us" class=" ms-md-3 btn text-decoration-none btn-light-purple btn__block__btn_second">
                                {{ lang === 'ar-sa' ? 'تواصل معنا للمساعدة' : 'Contact Us' }}
                            </a>
                        </div>
                    </div>
                </div>
                <!--                <ul class="d-flex breadcrumb-list">-->
                <!--                    <li class="breadcrumb-item"><a href="/" class="text-decoration-none">{{ breadCrumbs && breadCrumbs.home }} </a></li>-->
                <!--                    <li class="breadcrumb-item active">{{ breadCrumbs && breadCrumbs.active }}</li>-->
                <!--                </ul>-->

                <div style="padding-top: 35px" class="request-3d-print-block">
                    <div style="margin-top: 0; width: 800px; background: white" class="col-md-10 col-xxl-5 mx-md-auto form-request__design-block" id="form-request__design-block">
                        <form data-url="" class="js-request-form" method="post">

                            <h2>{{ titles && titles.header }}</h2>
                            <p class="description-paragraph">
                                <template v-if="lang === 'ar-sa'">
                                    إذا كنت ترغب في تصميم فريد خاص بك، ولكن ليس لديك رسم تخطيطي،
                                    <a href="/contact-us">
                                        اكتب لنا
                                    </a>
                                    وسنتواصل معك.
                                </template>
                                <template v-else>
                                    If you want your own unique design, but you do not have a sketch,
                                    <a href="/contact-us">
                                        write to us
                                    </a>
                                    and we will contact you
                                </template>
                            </p>
                            <div class="form-group justify-content-between w-100">
                                <div class="mb-4">
                                    <label>{{ titles.name }}</label>
                                    <input type="text" class="js-request-name input" name="name" :value="this.userName" />
                                    <span class="text-danger error name_error"></span>
                                </div>

                                <div class="mb-4 form-group">
                                    <label>{{ titles.email }}</label>
                                    <input type="email" class="js-request-email input" name="email"
                                           :value="this.userEmail" />
                                    <span class="text-danger error email_error"></span>
                                </div>

                                <div class="mb-4 form-group">
                                    <label>{{ titles.phone }}</label>
                                    <input type="phone" class="js-request-phone input" name="phone"
                                           :value="this.userPhone" />
                                    <span class="text-danger error phone_error"></span>
                                </div>

                                <div class="mb-4 form-group">
                                    <label>{{ titles.category }}</label>
                                    <!--                                <input type="select" class="js-request-category input" name="category"/>-->
                                    <select name="category" id="">
                                        <option v-for="category in this.categories" :value="category">{{ category }}
                                        </option>
                                    </select>
                                    <span class="text-danger error category_error"></span>
                                </div>

                                <div class=" form-group d-flex flex-column">
                                    <label>{{ titles.request_type }}</label>
                                    <div class="d-flex">
                                        <input type="radio" class="js-request-type input custom-checkbox request-checkbox"
                                               name="type" value="Design" id="design-checkbox" />
                                        <label for="design-checkbox">{{ titles.design }}</label>
                                    </div>
                                    <div class="d-flex">
                                        <input type="radio" class="js-request-type input custom-checkbox request-checkbox"
                                               name="type" value="Design & Print" id="design-print-checkbox" />
                                        <label for="design-print-checkbox">{{ titles.designAndPrint }}</label>
                                    </div>
                                    <span class="text-danger error type_error"></span>
                                </div>

                                <div class="form-group">
                                    <label>{{ titles.describe }}</label>
                                    <textarea type="text" class="js-request-description input"
                                              :placeholder="lang === 'ar-sa' ? 'يرجى تقديم الحجم المطلوب للمنتج بالسنتيمتر (على سبيل المثال، 10 × 15 × 20 سم)' : 'Please provide the desired size of the product in centimetres (e.g., 10 x 15 x 20 cm)'"
                                              name="text"></textarea>
                                    <span class="text-danger error text_error"></span>
                                </div>

                                <div class="request-upload mt-3">
                                    <p class="text-start">
                                        {{ lang === 'ar-sa' ?
                                        'إذا كانت لديك مواد مرجعية مثل النماذج ثلاثية الأبعاد أو الرسومات أو الصور، يُرجى مشاركتها لتحسين الأداء.'
                                        :
                                        'If you have reference materials such as 3D models, sketches, or images, please share them for improved performance.'
                                        }}

                                    </p>
                                    <div class="position-relative mt-3 custom-upload-container d-flex">
                                        <label for="upload-file-request" class="d-flex gap-4 align-items-center">
                                            <span class="text-nowrap">{{ titles.upload }}</span><img
                                            src="../../../../public/images/icons/upload.svg" class="ms-3" alt="">
                                        </label>
                                        <input type="file" id="upload-file-request" accept=".3mf,.stl,.obj"
                                               class="form-control custom-upload " ref="myFilesInput" value="" name="file">
                                    </div>
                                    <p class="text-start">FBX, DWG, and PDF</p>
                                    <span class="text-danger error file_error"></span>
                                </div>
                            </div>

                            <button type="button" class="btn h-100 btn-purple text-white mt-5 w-100  js-send-request"
                                    @click="sendReguest">
                                {{titles.send}}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
import CardModelComponent from "./CardModelComponent";
import TheLoaderComponent from "./TheLoaderComponent";
import DropFileComponent from "./DropFileComponent";

export default {
    components: {
        DropFileComponent,
        CardModelComponent,
        TheLoaderComponent
    },
    data() {
        return {
            userName: '',
            userEmail: '',
            userPhone:'',
            showLoader: false,
            products: [],
            categories: [
                'Product Prototype',
                'Architectural Model',
                'Artistic',
                'Functional Part',
                'Educational',
            ],
            files: null,
            isFileError: false,
            lang: window.currentlang,
            titles: {
                header: '',
                description: '',
                name: '',
                email: '',
                describe: '',
                upload: '',
                send: '',
                category: '',
                request_type: '',
                design: '',
                designAndPrint: ''

            },
            breadCrumbs: {
                home: '',
                active: ''
            }
        }
    },

    mounted() {
        this.clearErrorInout()
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
        this.getUserInfo();
    },

    methods: {
        getUserInfo() {
          axios.get('/user/get-info').then( (response) => {
              this.userName = response.data.first_name;
              this.userEmail = response.data.email;
          });
        },
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.titles.header = 'طلب تصميم وطباعة لنماذج ثلاثية الأبعاد'
                this.titles.description = 'إذا كان عندك فكرة، وتحتاج تصميم للفكرة ، عبي النموذج وراح نتواصل معك ونضبطك'
                this.titles.name = 'الاسم الكامل'
                this.titles.email = 'البريد الإلكتروني'
                this.titles.phone = 'رقم الهاتف'
                this.titles.describe = 'اعطينا شرح لتفاصيل فكرتك'
                this.titles.upload = 'رفع ملفات داعمة'
                this.titles.send = 'إرسال'
                this.titles.category = 'نوع التصميم'
                this.titles.request_type = 'نوع الطلب'
                this.titles.design = 'تصميم'
                this.titles.designAndPrint = 'تصميم وطباعة'
                this.breadCrumbs.home = 'الرئيسية'
                this.breadCrumbs.active = 'Design and print request'
            } else {
                this.lang = 'en'
                this.breadCrumbs.home = 'Home'
                this.breadCrumbs.active = 'Design and print request'

                this.titles.header = 'Make your design request'
                this.titles.description = 'If you want your own unique design, but you do not have a sketch, write to us and we will contact you'
                this.titles.name = 'Name'
                this.titles.email = 'Email'
                this.titles.phone = 'Phone number'
                this.titles.describe = 'Describe your design idea'
                this.titles.upload = 'Upload file'
                this.titles.send = 'Send'
                this.titles.category = 'Design Category'
                this.titles.request_type = 'Request Type'
                this.titles.design = 'Design'
                this.titles.designAndPrint = 'Design & Print'
            }
        },
        sendReguest() {
            let vm = this
            let form = document.querySelector('.js-request-form')
            let typeInput = document.querySelector('input[name="type"]:checked');

            let data = new FormData(form)
            let input = document.querySelector('#upload-file-request')

            data.delete('file')
            data.append('file', input.files[0] || null)
            data.append('request_type', typeInput?.value || null);
            vm.showLoader = true
            axios.post('/request', data).then(function (response) {
                vm.showLoader = false
                if (localStorage.getItem('lang') === 'ar-sa') {
                    response && window.notify('تم إنشاء الطلب')
                } else {
                    response && window.notify('Request created')

                }
                form.reset();

            }).catch(function(error){
                vm.errorClientModel(error)
                vm.showLoader = false
                if (localStorage.getItem('lang') === 'ar-sa') {
                    window.notify('لم يتم إنشاء الطلب', 'error')
                } else {
                    window.notify('Request not created', 'error')

                }


            })
        },
        clearErrorInout() {
            let inputs = document.querySelectorAll('.input')
            inputs.forEach(input => {
                input.addEventListener('input', e => {
                    let parent = e.target.closest('div')
                    let child = parent.querySelector('.error')
                    child && (child.innerHTML = '')
                })
            })
        },
        errorClientModel(error) {
            function createErrorItem(error,selectName,name) {
                let errorSelect = document.querySelector(selectName)
                name && (errorSelect.innerHTML = name[0])
            }

            createErrorItem(error,'.name_error',error.response.data.errors.name)
            createErrorItem(error,'.email_error',error.response.data.errors.email)
            createErrorItem(error,'.phone_error', error.response.data.errors.phone)
            createErrorItem(error,'.text_error',error.response.data.errors.text)
            createErrorItem(error,'.file_error',error.response.data.errors.file)
        },
    }
}
</script>

<style lang="scss">
@import "../../sass/front/contacts";
</style>
